import type { TouchpointVersionAttributes } from "hooks/api/use-touchpoint-versions";

export const getVersionStatusTexts = ({ version = 1, status }: TouchpointVersionAttributes) => {
  return {
    statusLiveText: `v${version} (Published)`,
    statusDraftText: `v${version} (Draft)`,
    statusArchivedText: `v${version} (Archived)`,
    statusArchivedDraftText: `v${version} (Archived Draft)`,
    statusCreatedText: `v${version} (Created)`,
    statusClientReviewText: `v${version} (In Review)`,
    statusApprovedText: `v${version} (Approved)`,
    statusRejectedText: `v${version} (Feedback Received)`,
    statusSystemDraftText: `v${version} (Feedback Received)`,

    status: status,
  };
};
